const Canopy = ({ className = '', a = '#B50A00', b = '#F6EFE3', trim = '#FFB000' }) => {
  const stripes = [];
  const W = 1440;
  const sw = 72;
  const colors = [a, b];
  for (let x = 0, i = 0; x < W; x += sw, i++) {
    stripes.push(
      <rect key={i} x={x} y={0} width={sw} height={74} fill={colors[i % 2]} />
    );
  }
  const scallops = [];
  for (let x = 0, i = 0; x < W; x += sw, i++) {
    scallops.push(
      <path
        key={i}
        d={`M ${x} 74 A ${sw / 2} 30 0 0 0 ${x + sw} 74 Z`}
        fill={colors[i % 2]}
      />
    );
  }
  return (
    <div className={`pointer-events-none select-none ${className}`} aria-hidden="true" data-testid="market-canopy">
      <svg viewBox={`0 0 ${W} 108`} preserveAspectRatio="none" className="block h-full w-full animate-canopy-sway" style={{ transformOrigin: 'top center' }}>
        <rect x={0} y={0} width={W} height={10} fill="#000515" opacity={0.12} />
        {stripes}
        {scallops}
        <rect x={0} y={70} width={W} height={4} fill={trim} />
      </svg>
    </div>
  );
};

export default Canopy;
